import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { TrailingTooltip } from "@vds/tooltips";
import { convertStringToElements } from "@vds/html-parsers";
import { TextLink } from "@vds/buttons";

import { media } from "utils/style";
import { Accordion, AccordionItem, AccordionHeader,AccordionTitle, AccordionSubTitle, AccordionDetail  } from "@vds/accordions"; 
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";

import { decryptData } from "utils/decryptData";

import AuthorizedAgentCorrectionForm from "../../Layout/MainContent/AuthorizedAgent/AuthorizedAgentCorrectionForm/AuthorizedAgentCorrectionForm";


class CorrectiblePageAccordion extends Component {
  truncate = text => {
    return text;
  };
  state={
    expanded:false
  }

  componentDidMount() {
    if (this.props.categoryId) {
      const data = [this.props.categoryId];
      this.handleChange(data);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isFormerCorrectionFlow
      && this.props.selectedFormerAccount
      && this.props.selectedFormerAccount.length > 0
      && prevProps.selectedFormerAccount
      && prevProps.selectedFormerAccount.length > 0
    ) {
      if (this.props.selectedFormerAccount[0].billingAccountNumber && this.props.selectedFormerAccount[0].billingAccountNumber !== prevProps.selectedFormerAccount[0].billingAccountNumber) {
        if (this.props.selectedFormerBox) {
          this.props.fetchFormerRequestHistory(this.props.selectedFormerAccount[0])
          this.props.canceSelectedBoxCall()
        } else {
          if (this.props.categoryId) {
            const data = [this.props.categoryId];
            this.handleChange(data);
          }
        }
      }
    }
  }


  handleChange = data => {
    if (data) {
      if (this.props.isFormerCorrectionFlow) {
        if (this.props.selectedFormerAccount && this.props.selectedFormerAccount.length > 0) {
          this.props.fetchCorrectibleFormer(data, this.props.selectedFormerAccount[0]);
        }
      }
      else if (this.props.isAgentCorrectionFlow) {
        if (this.props.agentSelectedMtn && this.props.agentSelectedMtn.trim().length > 0) {
          this.props.fetchCorrectibleAgent(data, this.props.agentSelectedMtn);
        }
      }
      else {
        this.props.fetchCorrectible(data);
      }


      const element = document.activeElement;
      const offset = 125;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  setUrlAndQueryParamSeparator = (url) => {
    return url && url.indexOf("?") !== -1
      ?
      "&"
      :
      "?"
  };

  hidebutton = (elementIdxPos, agentArray, name, idx) => {

    for (let i = 0; i < agentArray.length; i++) {
      if (elementIdxPos != i && name != agentArray[i].attrName) {
        document.getElementById('content' + i + agentArray[i].attrName.split(' ').join('')).style.display = "";
        document.getElementById('button' + i + agentArray[i].attrName.split(' ').join('')).style.display = "";
      }
      else {
        document.getElementById('content' + elementIdxPos + name.split(' ').join('')).style.display = "none";
        document.getElementById('button' + elementIdxPos + name.split(' ').join('')).style.display = "none";
      }
    }

  }

  showButton = (elementIdxPos, name) => {
    document.getElementById('content' + elementIdxPos + name.split(' ').join('')).style.display = "";
    document.getElementById('button' + elementIdxPos + name.split(' ').join('')).style.display = "";
  }

  getAllIndexofsubLevelCategories(arr) {
    if (arr && arr.length > 0) {
      return arr.map(function (_, index) {
        return index
      })
    }
  }

  render() {
    const preExpanded = [this.props.categoryId];
    // const preExpandedSubAccordion = [this.props.subCategoryId];

    const hasNoDataElement = this.props.topLevelCategories.find(item => item.category_id === "nodata");
    const elementId = this.props.elementId;
    const categoryId = this.props.categoryId;
    const subCategoryId = this.props.subCategoryId;
    const elementIdx = this.props.elementIdx;
    const elementsData = this.props.correctibleHistory || [];
    const editedElements = this.props.editedElements || [];
    const lob = this.props.lob;
    const showRepFlowModal = this.props.showRepFlowModal;
    const showEditableFormForAuthorizedAgent = this.props.showEditableFormForAuthorizedAgent;
    const submitAuthorizedAgentEditedFormData = this.props.submitAuthorizedAgentEditedFormData;
    const showRepFlowModalForAuthorizedAgent = this.props.showRepFlowModalForAuthorizedAgent;
    const repFlowModalForAuthorizedAgentCancelClick = this.props.repFlowModalForAuthorizedAgentCancelClick;
    const accordion_key = this.props.selectedFormerAccount && this.props.selectedFormerAccount[0] ? this.props.selectedFormerAccount[0].billingAccountNumber : ""
    const showEditbuttonAgent = this.props.showEditbuttonAgent

    return (
      <div className="accordion_container" key={accordion_key}>
        <Accordion type='single' topLine={false} bottomLine={false}  className="main_accordion">
          {this.props.topLevelCategories.map(
            item =>
              (item.category_id !== "nodata" && item.category_description_correctible) || (lob === "agent" && item.category_id !== "nodata") ? (
                <AccordionItem  key={item.category_id} uuid={item.category_id}>
                  <AccordionHeader onClick={() =>this.handleChange(item.category_id)} trigger={{type:'icon',openLabel:'Explore',closeLabel:'Collapse'}}>
                  <AccordionTitle><TopLevelHeader>{item.category_name}</TopLevelHeader></AccordionTitle>
                      <AccordionSubTitle>
                        {item.category_description_correctible}  
                      </AccordionSubTitle>
                  </AccordionHeader>
                    <AccordionDetail>
                      {this.props.loading ? (
                        <RectangleLoader style={{padding:'0'}}/>
                      ):
                      (
                        <Fragment>
                              {item.category_sub_description_correctible ? (
                                <CategorySubDescription>
                                {convertStringToElements(item.category_sub_description_correctible)}
                                </CategorySubDescription>
                              ) : null}
                              <Accordion preExpanded={this.getAllIndexofsubLevelCategories(this.props.subLevelCategories)} topLine={false} bottomLine={false} className="sub_accordion" allowZeroExpanded allowMultipleExpanded>
                                {this.props.subLevelCategories.length ? (
                                  this.props.subLevelCategories.map((subItem, idx) => (
                                    <AccordionItem alwaysOpen={true} key={subItem.header} uuid={idx}>
                                      <AccordionHeader   aria-level="4" triggerType='icon'>
                                        {/* <AccordionItemButton className="sub_accordion_button"> */}
                                        <AccordionTitle>
                                        <SubLevelHeader> {convertStringToElements(subItem.header)}</SubLevelHeader>
                                        </AccordionTitle>
                                        <AccordionSubTitle>
                                          <SubLevelHeaderDesc>
                                           {convertStringToElements(subItem.description)}
                                          </SubLevelHeaderDesc>
                                        </AccordionSubTitle>
                                        {/* </AccordionItemButton> */}
                                      </AccordionHeader>
                                      <Fragment>
                                        <AccordionDetail>
                                          {
                                            subItem.subdescription && (
                                              <SubCategoryDescription>
                                                {convertStringToElements(subItem.subdescription)}
                                              </SubCategoryDescription>
                                            )
                                          }
                                        {/* <AccordionItemPanel className="sub_accordion_panel"> */}
                                          {subItem.attributes.map((content, elementIdxPos) => (
                                            <Fragment key={content.attrName}>
                                              <SubAccordionPanel className={elementIdxPos === (subItem.attributes.length - 1) ? "lastItem" : ""}>
                                                <SubLevelHeader1 fieldWidth={"80%"} style={{ paddingRight: "5px", overflowWrap: "break-word" }}>{content.attrName}
                                                  {content.attrValue.map(value => (
                                                    <PanelContent id={"content" + elementIdxPos + content.attrName.split(' ').join('')} key={value}>
                                                      <P data-qm-encrypt="true" color={"#6F7171"}>{decryptData(value)}</P>
                                                      {content.tooltip_information && ( 
                                                                                                              
                                                        <TrailingTooltip                                                        
                                                        surface="light"
                                                        typographySize="small"
                                                        typographyPrimitive="p"
                                                        typographyType="body"
                                                        tooltipSize="small"                                                        
                                                        bold={false}
                                                         tooltipContent= {<p className="tooltip">{convertStringToElements(content.tooltip_information)}</p>} 
                                                        >                                                        
                                                        </TrailingTooltip>
                                                      )}
                                                    </PanelContent>
                                                  ))}
                                                  {content.attrId === this.props.authorizedAgentEditedElementId && content.attrName === this.props.authorizedAgentEditedElement.attrName && this.props.showEditableForm && (
                                                    <ElementStatus style={{ width: "43%" }}>
                                                      <div>
                                                        <AuthorizedAgentCorrectionForm
                                                          elementId={content.attrId}
                                                          element={content}
                                                          showRepFlowModalForAuthorizedAgent={showRepFlowModalForAuthorizedAgent}
                                                          onCancel={repFlowModalForAuthorizedAgentCancelClick}
                                                          onSubmit={(e) => { submitAuthorizedAgentEditedFormData(e, item.category_id, content.attrId, content.userFriendlyName) }}
                                                          onHideDateShow={() => { this.showButton(elementIdxPos, content.attrName) }}
                                                        />
                                                      </div>
                                                    </ElementStatus>
                                                  )
                                                  }
                                                  <ElementStatus>
                                                    {
                                                      (elementId && content.attrId === elementId) &&
                                                      (categoryId && item.category_id === categoryId) &&
                                                      (idx === subCategoryId) &&
                                                      (elementIdxPos === elementIdx)
                                                      && (
                                                        <Fragment>
                                                          {
                                                            true === this.props.isFormerCorrectionFlow || (content.repAssisted && content.repAssisted.indexOf(lob) !== -1)
                                                              ?
                                                              this.props.elementUpdateStatusRep &&
                                                              (
                                                                <ElementStatus>{/*<span><Icon name="warning" size="medium" color="#cd040b"/></span>*/}
                                                                  <P color={"#007EED" /*Blue*/}>
                                                                   {this.props.elementUpdateStatusRep}
                                                                  </P>
                                                                </ElementStatus>
                                                              )
                                                              :
                                                              (
                                                                <ElementStatus>
                                                                  {/*<span><Icon name="checkmark-alt" size="medium" color="#0b882d"/></span>*/}
                                                                  <P color={"#0B882D"}>
                                                                    {this.props.elementUpdateStatus}
                                                                  </P>
                                                                </ElementStatus>
                                                              )
                                                          }
                                                        </Fragment>
                                                      )
                                                    }
                                                    {
                                                      (this.props.isAgentCorrectionFlow) &&
                                                      (content.attrId === this.props.authorizedAgentEditedElementId) &&
                                                      (this.props.authorizedAgentEditedElementUpdateStatus === true) &&
                                                      (this.props.elementUpdateStatusRep && this.props.elementUpdateStatusRep.trim().length > 0)
                                                      && (
                                                        <Fragment>
                                                          {
                                                            /*content.repAssisted && content.repAssisted.indexOf(lob) !== -1
                                                            ?
                                                                this.props.elementUpdateStatusRep &&
                                                                (<ElementStatus>
                                                                <P color={"#007EED"} top={"2px"}>
                                                                  {this.props.elementUpdateStatusRep}
                                                                </P></ElementStatus>)
                                                            :*/
                                                            <ElementStatus>
                                                              <P color={"#007EED"}>
                                                                {this.props.elementUpdateStatusRep}
                                                              </P>
                                                            </ElementStatus>
                                                          }
                                                        </Fragment>
                                                      )
                                                    }
                                                    {
                                                      elementsData &&
                                                        elementsData.filter((data) =>
                                                          data.elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                          && data.requestType === "CORRECT"
                                                          && data.status === "IN_PROGRESS"
                                                        ).length > 0 ||

                                                        (elementsData &&
                                                          elementsData.filter((data) =>
                                                            data.elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                            && data.requestType === "CORREGIR"
                                                            && data.status === "IN_PROGRESS"
                                                          ).length > 0 ? "disabled" : ""
                                                        )
                                                        ?
                                                        <Fragment>
                                                          <ElementStatus>
                                                            {/*<span><Icon name="warning" size="medium" color="#007EED"/></span>*/}
                                                            <P color={"#007EED"}>
                                                              {this.props.elementHistoryStatusRep}
                                                            </P>
                                                          </ElementStatus>
                                                        </Fragment>
                                                        :
                                                        ""
                                                    }
                                                  </ElementStatus>
                                                </SubLevelHeader1>
                                                {/*<PanelContent key={content.attrName} style={{maxWidth:`${elementId.length > 0 ? "12%" : "20%"}`}}>*/}
                                                <PanelContent id={"button" + elementIdxPos} key={content.attrName}>
                                                  {
                                                    true === this.props.isFormerCorrectionFlow || content.repAssisted && content.repAssisted.indexOf(lob) !== -1
                                                      ?
                                                      <TextLink
                                                        disabled={
                                                          (elementsData &&
                                                            elementsData.filter((data) =>
                                                              data.elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                              && data.requestType === "CORRECT"
                                                              && data.status === "IN_PROGRESS"
                                                            ).length > 0 ? true : false
                                                          )
                                                          ||
                                                          (
                                                            editedElements &&
                                                              editedElements.filter((elementId) =>
                                                                elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                              ).length > 0 ? true : false
                                                          )
                                                        }                                                        
                                                        type="standAlone"
                                                        style= {{  fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif"}}
                                                        aria-label={`${content.userFriendlyName} edit`}
                                                        key={content.attrName}
                                                        background={"white_background"}
                                                        onClick={(e) => { showRepFlowModal(item.category_id, idx, elementIdxPos, content.attrId, content.userFriendlyName) }}
                                                      >
                                                        {"Edit"}
                                                        </TextLink>
                                                      :
                                                      (
                                                        lob === "agent"
                                                          ?
                                                          <TextLink
                                                            disabled={
                                                              (elementsData &&
                                                                elementsData.filter((data) =>
                                                                  data.elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                                  && data.requestType === "CORRECT"
                                                                  && data.status === "IN_PROGRESS"
                                                                ).length > 0 ? true : false
                                                              ) ||
                                                              (elementsData &&
                                                                elementsData.filter((data) =>
                                                                  data.elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                                  && data.requestType === "CORREGIR"
                                                                  && data.status === "IN_PROGRESS"
                                                                ).length > 0 ? true : false
                                                              )
                                                              ||
                                                              (
                                                                editedElements &&
                                                                  editedElements.filter((elementId) =>
                                                                    elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                                  ).length > 0 ? true : false
                                                              )
                                                            }
                                                            id={"button" + elementIdxPos + content.attrName.split(' ').join('')}
                                                            key={content.attrName}
                                                            style= {{  fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif"}}
                                                            background={"white_background"}                                                            
                                                            type="standAlone"
                                                            aria-label={`${content.userFriendlyName}`}
                                                            onClick={(e) => {
                                                              this.hidebutton(elementIdxPos, subItem.attributes, content.attrName, idx);
                                                              showEditableFormForAuthorizedAgent(content.attrId, content, idx, item.category_id);
                                                              showEditbuttonAgent(elementIdxPos, content.attrName)
                                                            }}
                                                          >
                                                            {"Edit"}
                                                          </TextLink>
                                                          :                                                           
                                                            <TextLink
                                                              disabled={
                                                                (elementsData &&
                                                                  elementsData.filter((data) =>
                                                                    data.elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                                    && data.requestType === "CORRECT"
                                                                    && data.status === "IN_PROGRESS"
                                                                  ).length > 0 ? true : false
                                                                )
                                                                ||
                                                                (
                                                                  editedElements &&
                                                                    editedElements.filter((elementId) =>
                                                                      elementId === item.category_id + ":" + content.attrId + "-" + content.userFriendlyName
                                                                    ).length > 0 ? true : false
                                                                )
                                                              }
                                                              key={content.attrName}
                                                              style= {{  fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif"}}
                                                              href={content[`${lob}Url`] + this.setUrlAndQueryParamSeparator(content[`${lob}Url`]) + "src=VPD&elementId=" + item.category_id + ":" + content.attrId + "-" + content.userFriendlyName + "&categoryId=" + item.category_id + "&subCategoryId=" + idx + "&elementIdx=" + elementIdxPos}
                                                              background={"white_background"}
                                                              type="standAlone"                                                         
                                                              aria-label={`${content.userFriendlyName} edit`}
                                                            >
                                                              {"Edit"}
                                                            </TextLink>
                                                           
                                                      )
                                                  }

                                                  {/*-- disabled temporarily     
                                                <StyledLinkSmall
                                                  key={content.attrName}
                                                  background={"white_background"}        
                                                  linkType="anchor"
                                                  href={content[`${lob}Url`]+"?src=VPD&elementId="+content.attrId+"-"+content.attrName+"&categoryId="+item.category_id+"&subCategoryId="+idx}
                                                >
                                                  {"Edit"}
                                                </StyledLinkSmall>                                              
                                                */}
                                                </PanelContent>

                                              </SubAccordionPanel>
                                              {/* {content.attrId === this.props.authorizedAgentEditedElementId && content.attrName === this.props.authorizedAgentEditedElement.attrName && this.props.showEditableForm && (
                                                <div>
                                                  <AuthorizedAgentCorrectionForm
                                                    elementId={content.attrId}
                                                    element={content}
                                                    showRepFlowModalForAuthorizedAgent={showRepFlowModalForAuthorizedAgent}
                                                    onCancel={repFlowModalForAuthorizedAgentCancelClick}
                                                    onHideDateShow = {()=>{this.showButton(elementIdxPos,)}}
                                                    onSubmit={(e) => { submitAuthorizedAgentEditedFormData(e, item.category_id, content.attrId, content.userFriendlyName) }}
                                                  />
                                                </div>
                                              )
                                              } */}
                                            </Fragment>
                                          ))}
                                          </AccordionDetail>
                                        {/* </AccordionItemPanel> */}
                                      </Fragment>
                                    </AccordionItem>
                                  ))
                                ) : this.props.error ? (
                                  <p>{this.props.error}</p>
                                ) : (
                                  <p>
                                    {(hasNoDataElement && hasNoDataElement.category_description) ||
                                      "We don't have this information about you for this category."}
                                  </p>
                                )}
                              </Accordion>
                            {/* // </AccordionItemPanel> */}
                          </Fragment>
                        )
                }      
                </AccordionDetail>
                </AccordionItem>
              ) : null
          )}
        </Accordion>
      </div>
    );
  }
}

CorrectiblePageAccordion.propTypes = {
  fetchCorrectible: PropTypes.func.isRequired,
  topLevelCategories: PropTypes.array.isRequired,
  elementId: PropTypes.string,
  elementUpdateStatus: PropTypes.string,
  lob: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  subLevelCategories: PropTypes.array.isRequired
};

export default CorrectiblePageAccordion;

const SubCategoryDescription = styled.div`
  /*Description just below the sub-level category name upon expanding*/

  max-width: 620px;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color:#6F7171;

  p {
    margin: 20px 0;
  }

  p:first-of-type {
    margin-top: 0;
  }

  div,p{
   font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
   font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px;
   color:#6F7171;
  }

  div,p,a{
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color:#6F7171;
  }

  div,p:first-of-type{
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; 
    letter-spacing: 0.5px;
    color:#000;
  }

  ${media.mobile`
    max-width: 90%;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 15px;
    
    p {
      margin: 15px 0;
    }
    p:first-of-type {
      margin-top: 0;
    }
  `}
`;

const PanelContent = styled.div`
  display: flex;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  
  ${({ panelWidth }) =>
    panelWidth && `max-width: ${panelWidth};`
  }

  ${media.mobile`
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.5px;
  `}
`;

// const AccordionItemPanel = styled(AccordionPanel)`
//   &.noDataAvailable {
//     padding: 10px 0 24px 0;
//   }
// `;

const SubLevelHeaderDesc = styled.span`
  max-width: 620px;
  display: inline-block;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #6F7171;

  ${media.mobile`
    display: inline-block;
    max-width: 90%;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.5px;
    color: #6F7171;
  `}
`;

const TopLevelHeader = styled.span`
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  ${media.mobile`
    display: inline-block;
    max-width: 90%;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 0;
  `};
`;

const Span = styled.span`
  margin-top: 8px;
  display: block;
  max-width: 691px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #6F7171;

  ${media.mobile`
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.5px;
    max-width: 90%;
    color: #6F7171;
  `};
`;

const CategorySubDescription = styled.p`
  max-width: 597px;
  margin: 5px 0 25px 0;

  ${media.tablet`
    width: 75%;
  `};

  ${media.mobile`
    width: 100%;
  `};
`;

const SubLevelHeader = styled.span`
  display: block;
  flex: 1;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  max-width: 100%;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 10px;

  ${({ fieldWidth }) =>
    fieldWidth && `max-width: ${fieldWidth};`
  }

  ${media.mobile`
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    max-width: 73%;
    margin-bottom: 4px;
  `};
`;

const SubLevelHeader1 = styled.span`
  /* Key-Value pair of data */

  display: block;
  flex: 1;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  max-width: 100%;
  margin-bottom: 10px;

  ${({ fieldWidth }) =>
    fieldWidth && `max-width: ${fieldWidth};`
  }

  ${media.mobile`
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    max-width: 73%;
    margin-bottom: 4px;
  `};
`;

const SubAccordionPanel = styled.div`
  width: 100%;
  margin: 15px 0 24px 0px;
  display: flex;
  align-items: center;
  padding: 15px 0px 15px 0px;
  border-bottom: 1px solid #D8DADA;

  &.lastItem{
    border-bottom: none;
  };

  ${media.mobile`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  `};
`;

const ElementStatus = styled.div`
  display: flex;

  ${media.mobile`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    gap: 2px;  
    margin-bottom:6px;
  `};
`;

const P = styled.p`
  padding: 10px 15px 5px 0;
  overflow-wrap: anywhere;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  ${({ color }) =>
    color && `color: ${color}; font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;`
  }

  ${({ top }) =>
    top && `padding-top: ${top};`
  }

  ${media.mobile`
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-align: left;    
  `};
`;

const UnderlinedButton = styled.button`
  background: 0;
  border: 0;
  margin: 8px 0 0 83px;
  cursor: pointer;
  text-decoration: underline;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;

  ${media.mobile`
    text-decoration: underline;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.5px;
  `};
`;